exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid-feedback[data-v-2b822a78]{position:absolute}.is-invalid[data-v-2b822a78]{border-color:#dc3445!important}.fade-enter-active[data-v-2b822a78],.fade-leave-active[data-v-2b822a78]{transition:opacity .5s}.fade-enter[data-v-2b822a78],.fade-leave-to[data-v-2b822a78]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b822a78","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contactform.vue
// module id = 390
// module chunks = 0